export default "__VITE_ASSET__6sgaB6pw__"